<template>
  <div class="topbar-preview" v-show="judge">
    <!-- 遮罩 -->
    <div class="mask-content" @click="isVipMaterial = false">
      <div class="mask-top" :style="maskTopStyle"></div>
      <div class="mask-left" :style="maskLeftStyle"></div>
      <div class="mask-right" :style="maskRightStyle"></div>
      <div class="mask-bottom" :style="maskBottomStyle"></div>
      <!-- <div id="subtitle-player" :style="subtitleplayerStyle"></div> -->
    </div>
    <!-- 关闭按钮 -->
    <div class="preview-close" :style="closeStyle">
      <div
        v-show="
          isShowMaterialRisk
        "
        class="vip-tip"
      >
        <span>您使用了VIP素材和功能，需要升级特定会员后才能导出。</span>
        <div class="details-link">
          <a @click.stop="toggleVipMaterial()">查看详情</a>
          <div v-if="isVipMaterial" class="vip-material-list">
            <rights v-if="isVipMaterial" :needAction="false" type="preview"></rights>
          </div>
        </div>
      </div>

      <div
        v-show="!this.IsDoingSmartVoice"
        class="close-button"
        @click="close(), (isVipMaterial = false)"
      >
        <i></i>
      </div>
    </div>
    <!-- 水印 -->
    <div
      v-show="UserLevel <= 0"
      class="preview-watermark"
      :style="watermarkStyle"
    ></div>
    <div v-show="isShowWatermark()" class="vip-mask" :style="vipMaskStyle">
      <div
        v-if="TOOL && TOOL.optimized != 'Horizontal'"
        class="contain-vips"
      ></div>
      <div v-else>视频中含有VIP素材或功能</div>
    </div>
    <!-- 时间和音量 -->
    <div v-if="type === 'preview'" class="time-volume" :style="timeVolumeStyle">
      <div class="time">
        <span>{{ playTime | secToMin }}/{{ totalTime | secToMin }}</span>
      </div>
      <div class="volume">
        <div class="volume-slider">
          <div class="v-slider-rc">
            <div class="v-slider-rail"></div>
            <div
              class="v-slider-track"
              :style="{ height: volumeSize + '%' }"
            ></div>
            <div
              v-volumeHandle
              class="v-slider-handle"
              :style="{ bottom: volumeSize + '%' }"
            ></div>
          </div>
        </div>
      </div>
    </div>
    <!-- 时间条和按钮 -->
    <div
      v-if="type === 'preview'"
      class="video-control"
      :style="videoControlStyle"
    >
      <div v-rcSliderClick class="slider-conntent">
        <div class="icon-before"></div>
        <div v-rcSliderClick class="rc-slider">
          <div class="rc-slider-rail"></div>
          <div
            class="rc-slider-track"
            :style="{ width: (nowTime / totalTime) * 100 + '%' }"
          ></div>
          <div
            v-dragHandle
            class="rc-slider-handle"
            :style="{ left: (nowTime / totalTime) * 100 + '%' }"
          ></div>
        </div>
        <div class="icon-after"></div>
      </div>
      <div class="control-button">
        <div v-if="IsDraftShareShown" class="share button button--primary" @click.stop="share($event)">
          分享项目
        </div>
        <div
          v-show="playStatus !== 'play'"
          @click="preview('play')"
          class="play"
        ></div>
        <div
          v-show="playStatus === 'play'"
          @click="preview('pause')"
          class="pause"
        ></div>
        <div @click="preview('stop')" class="stop"></div>
      </div>
    </div>
    <div
      v-else-if="type === 'record' && judge"
      class="record-control"
      :style="recordControlStyle"
    >
      <PreviewRecord
        :soundType="soundType"
        :nowTime="nowTime"
        :totalTime="totalTime"
      ></PreviewRecord>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import PreviewRecord from "./previewRecord";
import Rights from "../topnav/riskDrop/rights.vue";
import { getVipList as getVipSceneEffects } from '@/components/topnav/riskDrop/sceneEffectTypes.js';

//  弹窗组件，所欲设置的弹窗组件
import modal from "../mixins/modal";

export default {
  mixins: [modal],
  data() {
    return {
      modalName: "preview", // 用于弹开播放全局播放弹窗
      type: "preview", // 是否是全局播放还是录音播放
      soundType: "",
      playStatus: "stop", // 播放状态
      nowTime: 0, // 用于显示的播放时间
      playTime: 0, // 播放的时间（正常情况下与nowTime一样）
      nowTimePlay: 0, // 用于记录暂停后应该重新播放的时间记录
      startTime: 0, // 用于全局播放的开始时间
      totalTime: 10000, // 总时间
      timeNode: [0], // 每个scenes的时间节点数组
      dragHandle: false, // 判断是否处于拖动
      animFrame: null, // 用于取消requestAnimationFrame
      volumeSize: 100,
      oldFrame: 0,
      noLimitPlay: true, // 用于限制改变时间也不会触发播放事件
      isVipMaterial: false,
    };
  },
  computed: {
    ...mapGetters([
      "SetPanel_Size",
      "MaterialPane_Size",
      "TopNav_Size",
      "Tool_Size",
      "Window_Size",
      "TOOL",
      "SelectScenes_Msg",
      "IsVipSprites",
      "UserLevel",
      "IsDoingSmartVoice",
      "UserMsg",
      'IsDraftShareShown'
    ]),
    ...mapGetters({
      soundPlayHandle: "addSoundtrack/getPlayHandle",
      componyvipMaterial: 'resources/componyvipMaterial'
    }),
    subtitleplayerStyle() {
      const style = {};
      style.height = this.TOOL.clientHeight + "px";
      style.width = this.TOOL.clientWidth + "px";
      style.top = this.TOOL.fixTop + this.TopNav_Size.height + 40 + "px";
      style.left = this.TOOL.fixLeft + this.MaterialPane_Size.width + "px";

      return style;
    },
    maskTopStyle() {
      const style = {};
      style.height = this.TOOL.fixTop + this.TopNav_Size.height + 40 + "px";
      style.top = 0;
      style.left = 0;
      return style;
    },
    maskLeftStyle() {
      const style = {};
      style.width = this.TOOL.fixLeft + this.MaterialPane_Size.width + "px";
      style.height = this.Tool_Size.height - this.TOOL.fixTop * 2 - 40 + "px";
      style.top = this.TOOL.fixTop + this.TopNav_Size.height + 40 + "px";
      style.left = 0;
      return style;
    },
    maskRightStyle() {
      const style = {};
      style.width = this.TOOL.fixLeft + this.SetPanel_Size.width + "px";
      style.height = this.Tool_Size.height - this.TOOL.fixTop * 2 - 40 + "px";
      style.top = this.TOOL.fixTop + this.TopNav_Size.height + 40 + "px";
      style.right = 0;
      return style;
    },
    maskBottomStyle() {
      const style = {};
      style.height =
        this.Window_Size.height +
        this.TOOL.fixTop -
        this.TopNav_Size.height -
        this.Tool_Size.height +
        "px";
      style.top =
        this.TopNav_Size.height +
        this.Tool_Size.height -
        this.TOOL.fixTop +
        "px";
      style.right = 0;
      return style;
    },
    closeStyle() {
      const style = {};
      style.left = this.MaterialPane_Size.width + this.TOOL.fixLeft + "px";
      style.top = this.TOOL.fixTop + this.TopNav_Size.height + 40 - 34 + "px";
      style.height = "34px";
      style.width = this.TOOL.clientWidth + "px";
      return style;
    },
    videoControlStyle() {
      const style = {};
      style.width = this.TOOL.clientWidth + "px";
      style.left = this.TOOL.fixLeft + this.MaterialPane_Size.width + "px";
      style.top =
        this.TOOL.fixTop +
        this.TopNav_Size.height +
        40 +
        this.TOOL.clientHeight +
        "px";
      return style;
    },
    recordControlStyle() {
      const style = {};
      style.width = this.TOOL.clientWidth + "px";
      style.left = this.TOOL.fixLeft + this.MaterialPane_Size.width + "px";
      style.top =
        this.TOOL.fixTop +
        this.TopNav_Size.height +
        40 +
        this.TOOL.clientHeight +
        "px";
      return style;
    },
    timeVolumeStyle() {
      const style = {};
      style.right = this.TOOL.fixLeft + this.SetPanel_Size.width + 5 + "px";
      style.bottom =
        this.Window_Size.height +
        this.TOOL.fixTop -
        this.TopNav_Size.height -
        this.Tool_Size.height +
        10 +
        "px";
      return style;
    },
    watermarkStyle() {
      const style = {};
      let type = "";
      this.TOOL && (type = this.TOOL.optimized || "Vertical");
      if (type === "Horizontal") {
        style.width = this.TOOL.clientWidth + "px";
        style.height = this.TOOL.clientHeight + "px";
        style.top = this.TOOL.fixTop + this.TopNav_Size.height + 40 + "px";
        style.left = this.TOOL.fixLeft + this.MaterialPane_Size.width + "px";
        style.background =
          "url('../../../static/animengine/img/icon-default-watermark-h.png') 50% 50% / 100% 100% no-repeat";
      } else if (type === "Vertical") {
        let clientWidth = (this.TOOL.clientHeight * 9) / 16,
          clientHeight = this.TOOL.clientHeight;
        style.width = clientWidth + "px";
        style.height = clientHeight + "px";
        style.top = this.TOOL.fixTop + this.TopNav_Size.height + 40 + "px";
        style.left =
          this.TOOL.fixLeft +
          this.MaterialPane_Size.width +
          this.TOOL.clientWidth * 0.3418 +
          "px";
        style.background =
          "url('../../../static/animengine/img/icon-default-watermark-v.png') 50% 50% / 100% 100% no-repeat";
      }
      this.setWatermarkCloneStyle(style);
      return style;
    },
    vipMaskStyle() {
      const style = {};
      let type = "";
      this.TOOL && (type = this.TOOL.optimized || "Vertical");
      if (type === "Horizontal") {
        style.top =
          this.TOOL.fixTop +
          this.TopNav_Size.height +
          (this.TOOL.clientHeight - 140 / this.TOOL.scale) / 2 +
          "px";
        style.left = this.TOOL.fixLeft + this.MaterialPane_Size.width + "px";
        style.width = this.TOOL.clientWidth + "px";
        style.fontSize = 140 / this.TOOL.scale + "px";
      } else if (type === "Vertical") {
        style.top = this.TOOL.fixTop + this.TopNav_Size.height + 40 + "px";
        style.left = this.TOOL.fixLeft + this.MaterialPane_Size.width + "px";
        style.width = this.TOOL.clientWidth + "px";
        style.height = this.TOOL.clientHeight + "px";
      }

      return style;
    },
    isShowMaterialRisk () {
      if (this.UserMsg.payForMaterial || this.IsDoingSmartVoice) {
        return false;
      }
      return this.IsVipSprites && this.IsVipSprites.dataLength || getVipSceneEffects(this.TOOL.sprites).length;
    }
  },
  watch: {
    boxData(val) {
      if (this.judge) {
        this.type = this.dataMsg.preview.type || "preview";
        this.soundType = this.dataMsg.preview.select || "";
        this.noLimitPlay = true;
        this.nowTime = 0;
        this.volumeSize = 100;
        this.totalTime = this.TOOL.getDuration();
        this.TOOL.selectSprite();
        if (this.type !== "preview" && this.soundType !== "all") return;

        Promise.all(this.initEffect()).then(() => {
          this.getTimeNode();
          this.type === "preview" && this.preview("play");
        });
      }
    },
    nowTime(val, oldval) {
      this.addWatermarkClone();
      this.TOOL.eve.emit("subtitle_play_all", {
        isPlay: this.playStatus === "play",
        timeMS: val,
      });

      if (this.dragHandle && this.playStatus === "play") return;
      this.playTime = this.nowTime;
    },
    playTime(val, oldval) {
      // 三角拖块变化后，动画实现
      let data = this.calcFrame();
      if (!data) return;
      if (this.playStatus === "play") {
        if (data.frame - this.oldFrame < 0) {
          this.$bus.emit("switch_scenes_play", {
            time: this.playTime,
            id: data.id,
          });
        }
        this.oldFrame = data.frame;
      }

      this.noLimitPlay &&
        this.TOOL.eve.emit("playByFrame", data.frame, data.id);
      this.noLimitPlay && this.TOOL.eve.emit("play_" + data.id, data.frame);
    },
  },
  mounted() {
    this.$bus.on("preview-record-play", (data) => {
      data.status && this.preview(data.status);
    });
    this.$bus.on("record_close_complete", () => {
      this.close(true);
    });
    //console.log('preview.vue mounted()');
    this.dd
  },
  methods: {
    addWatermarkClone () {
      if (Date.now() - (this.stamp || 0) < 5000) return;
      const watermarkEle = this.$el.querySelector('.preview-watermark');
      if (this.UserLevel <= 0) {
        if (!this.watermarkClone) {
          this.watermarkClone = document.createElement('div');
          this.watermarkClone.classList.add('preview-watermark-clone');
        }
        const watermarkClone = this.watermarkClone;
        $(watermarkClone)
          .css({
            position: 'absolute',
            cursor: 'default',
            ...this.watermarkStyle
          })
          .appendTo(this.$el);
        this.stamp = Date.now();
        if (watermarkEle) {
          watermarkEle.style.opacity = 0;
        }
      }
    },
    setWatermarkCloneStyle (style) {
      if (!this.$el) return;
      const watermarkClone = this.$el.querySelector('.preview-watermark-clone');
      if (watermarkClone) {
        $(watermarkClone).css({
          position: 'absolute',
          cursor: 'default',
          ...style
        });
      }
    },
    toggleVipMaterial () {
      this.isVipMaterial = !this.isVipMaterial;
      if (this.isVipMaterial) {
        const cate = this.componyvipMaterial.length ? '企业会员': '个人会员';
        sensors.track("doratoonGuideePopup", {
          popup_content: '会员素材-预览', // 弹窗引导内容
          restricted_function: '会员素材-预览', // 受限功能
          popup_category1: [cate] // 弹窗分类
        });
      }
    },
    close(bol) {
      document.querySelector(".editorBtn .btn-sound").style.display = "";
      if (bol || this.type === "preview") {
        this.soundPlayHandle && this.soundPlayHandle.changePreviewVolume(100);
        this.noLimitPlay = false;
        this.preview("stop");
        // 将每个scenes播放时间回归
        for (let i = 0; i < this.TOOL.sprites.length; i++) {
          let scene = this.TOOL.sprites[i];
          let frame = Math.ceil(scene.nowTime * 60);
          // eve('playByFrame', null, frame, scene.id);
          this.TOOL.eve.emit("playByFrame", frame, scene.id);
          this.TOOL.eve.emit("play_" + scene.id, frame);
        }
        this.TOOL.cancelPlay();
        //释放一些占内存的资源
        this.TOOL.sprites.forEach((scenes) => {
          if (scenes.id !== this.SelectScenes_Msg.id) {
            scenes.unActiveAnimation();
          }
        });

        // 播放后所有的scenes被隐藏，选择让其显示
        this.TOOL.selectScenes(this.SelectScenes_Msg);
        this.closeModal();
      } else {
        this.$bus.emit("record_close_before");
      }
    },
    calcFrame() {
      // 计算播放到哪个scenes的帧数
      if (this.timeNode.length) {
        let data = {};
        for (let i = 0; i < this.timeNode.length - 1; i++) {
          if (
            this.playTime >= this.timeNode[i] &&
            this.playTime <= this.timeNode[i + 1]
          ) {
            data.frame = Math.ceil(
              ((this.playTime - this.timeNode[i]) / 1000) * 60
            );
            data.id = this.TOOL.sprites[i].id;
            return data;
          }
        }
      }
    },
    getTimeNode() {
      // 获取每个scenes组的开始和结束时间，并将scenes初始到第0帧
      if (this.TOOL && this.TOOL.sprites) {
        for (let i = 0; i < this.TOOL.sprites.length; i++) {
          let scene = this.TOOL.sprites[i];
          // eve('playByFrame', null, 0, scene.id)
          this.TOOL.eve.emit("playByFrame", 0, scene.id);
          this.TOOL.eve.emit("play_" + scene.id, 0);
          this.timeNode[i + 1] = scene.duration + this.timeNode[i];
        }
        this.TOOL.cancelPlay();
        // eve('playByFrame', null, 1, this.TOOL.sprites[0].id)
        this.TOOL.eve.emit("playByFrame", 1, this.TOOL.sprites[0].id);
        this.TOOL.eve.emit("play_" + this.TOOL.sprites[0].id, 1);
      }
    },
    preview(type) {
      // 播放暂停停止方法
      this.playStatus = type || "stop";
      this.startTime = 0;
      this.oldFrame = 0;
      window.cancelAnimationFrame(this.animFrame);
      this.animFrame = window.requestAnimationFrame(this.step);
      if (type === "play") {
        this.initScencePlay();
      }
      this.$bus.emit("timeline_play_all", {
        isPlay: type === "play" ? true : false,
        time: this.nowTime / 1000,
        noMusic: this.type === "preview" ? false : true,
      });

      this.TOOL.eve.emit("subtitle_play_all", {
        isPlay: this.playStatus === "play",
        timeMS: this.nowTime,
      });
    },
    step(timestamp) {
      // 实现播放，停止，暂停的具体实现
      if (this.playStatus === "stop") {
        window.cancelAnimationFrame(this.animFrame);
        this.nowTime = 0;
        this.nowTimePlay = 0;
      } else if (this.playStatus === "pause") {
        window.cancelAnimationFrame(this.animFrame);
        this.nowTimePlay = this.nowTime;
      } else if (this.playStatus === "play") {
        let progress = 0;
        if (!this.startTime) this.startTime = timestamp;
        progress = timestamp - this.startTime;
        this.playTime = this.nowTimePlay + progress;
        if (!this.dragHandle) {
          this.nowTime = this.playTime;
        }
        if (this.playTime < this.totalTime) {
          this.animFrame = window.requestAnimationFrame(this.step);
        } else {
          window.cancelAnimationFrame(this.animFrame);
          this.playStatus = "stop";
          this.$bus.emit("timeline_play_all", {
            isPlay: false,
            time: this.nowTime / 1000,
          });
          this.type === "preview" && (this.nowTime = 0);
          this.type === "preview" && (this.nowTimePlay = 0);
        }
      }
    },
    rcSliderClick(e) {
      // 点击进度条事件
      this.nowTime =
        ((e.pageX - this.TOOL.fixLeft - this.MaterialPane_Size.width) /
          this.TOOL.clientWidth) *
        this.totalTime;
      this.startTime = 0;
      this.nowTimePlay = this.nowTime;
      this.initScencePlay();
      this.$bus.emit("preview_mouseup", { time: this.nowTime });
      this.$bus.emit("timeline_play_all", {
        isPlay: this.playStatus === "play" ? true : false,
        time: this.nowTime / 1000,
      });
    },
    initScencePlay() {
      // 将当前播放的scenes后面的scenes初始化第0帧
      let isInit = false,
        nowId = "",
        frame = 0;
      for (let i = 0; i < this.timeNode.length - 1; i++) {
        if (isInit && this.TOOL.sprites[i]) {
          // eve('playByFrame', null, 0, this.TOOL.sprites[i].id);
          // this.TOOL.eve.emit("playByFrame", 0, this.TOOL.sprites[i].id);
          this.TOOL.player.scenesDict[this.TOOL.sprites[i].id].ele.hide();
          this.TOOL.sprites[i].effect.reset();
        }
        if (
          this.nowTime >= this.timeNode[i] &&
          this.nowTime <= this.timeNode[i + 1]
        ) {
          isInit = true;
          nowId = this.TOOL.sprites[i].id;
          frame = Math.ceil(((this.nowTime - this.timeNode[i]) / 1000) * 60);
        }
      }
      this.TOOL.player.maskEle.children().hide();
      // eve('playByFrame', null, frame, nowId);
      this.TOOL.eve.emit("playByFrame", frame, nowId);
      this.TOOL.eve.emit("play_" + nowId, frame);
    },
    changeVolume() {
      //TODO
      this.soundPlayHandle &&
        this.soundPlayHandle.changePreviewVolume(this.volumeSize);
    },
    initEffect() {
      let initArr = [];
      this.TOOL.sprites.forEach((scenes) => {
        initArr.push(scenes.effect.init());
      });
      return initArr;
    },
    share(ev) {
      let el = ev.target;
      let rect = el.getBoundingClientRect();
      this.$bus.emit("share.show", {
        left: rect.left + rect.width,
        top: rect.top,
      });
    },
    isShowWatermark() {
      let shouldPay = !this.UserMsg.payForMaterial;
      return shouldPay && this.IsVipSprites && this.IsVipSprites.dataLength;
    },
  },
  directives: {
    dragHandle(el, binding, vnode) {
      let _this = vnode.context,
        nowTime = 0,
        mousemove = null,
        mouseup = null,
        disx = 0;

      mousemove = (e) => {
        // 拖动改变时间
        var pre = ((disx - e.pageX) / _this.TOOL.clientWidth) * _this.totalTime;
        _this.nowTime =
          nowTime - pre < 0
            ? 0
            : nowTime - pre > _this.totalTime
            ? _this.totalTime
            : nowTime - pre;
        _this.startTime = 0;
        _this.nowTimePlay = _this.nowTime;
      };

      mouseup = (e) => {
        document.removeEventListener("mousemove", mousemove);
        document.removeEventListener("mouseup", mouseup);
        _this.nowTime = _this.playTime;
        _this.initScencePlay();
        _this.dragHandle = false;
        _this.$bus.emit("preview_mouseup", { time: _this.nowTime });
        _this.$bus.emit("timeline_play_all", {
          isPlay: _this.playStatus === "play" ? true : false,
          time: _this.nowTime / 1000,
        });
      };

      el.onmousedown = (e) => {
        e.preventDefault();
        e.stopPropagation();

        _this.dragHandle = true;
        nowTime = _this.nowTime;
        disx = e.pageX;

        _this.$bus.emit("preview_mousedown", { time: _this.nowTime });

        document.addEventListener("mousemove", mousemove);
        document.addEventListener("mouseup", mouseup);
      };
    },
    volumeHandle(el, binding, vnode) {
      let _this = vnode.context,
        volumeSize = 0,
        mousemove = null,
        mouseup = null,
        disy = 0;

      mousemove = (e) => {
        var pre = ((e.pageY - disy) / 70) * 100;
        _this.volumeSize =
          volumeSize - pre < 0
            ? 0
            : volumeSize - pre > 100
            ? 100
            : volumeSize - pre;
      };

      mouseup = (e) => {
        document.removeEventListener("mousemove", mousemove);
        document.removeEventListener("mouseup", mouseup);
        _this.changeVolume();
      };

      el.onmousedown = (e) => {
        e.preventDefault();
        e.stopPropagation();

        volumeSize = _this.volumeSize;
        disy = e.pageY;

        document.addEventListener("mousemove", mousemove);
        document.addEventListener("mouseup", mouseup);
      };
    },
    rcSliderClick(el, binding, vnode) {
      // 点击事件（为了和拖拽不冲突）
      let _this = vnode.context,
        mousemove = null,
        mouseup = null,
        isClick = false,
        dis = {
          x: 0,
          y: 0,
        };

      mousemove = (e) => {
        if (Math.abs(e.pageX - dis.x) >= 3 || Math.abs(e.pageY - dis.y) >= 3) {
          isClick = true;
        }
      };

      mouseup = (e) => {
        document.removeEventListener("mousemove", mousemove);
        document.removeEventListener("mouseup", mouseup);

        if (isClick) return;
        _this.rcSliderClick(e);
      };

      el.onmousedown = (e) => {
        e.preventDefault();
        e.stopPropagation();

        isClick = false;
        dis.x = e.pageX;
        dis.y = e.pageY;

        _this.$bus.emit("preview_mousedown", { time: _this.nowTime });

        document.addEventListener("mousemove", mousemove);
        document.addEventListener("mouseup", mouseup);
      };
    },
  },
  filters: {
    secToMin(duration) {
      if (duration <= 0) return "00:00";
      if (!duration) return "--:--";
      duration = parseFloat(duration / 1000);
      var min = Math.floor(duration / 60);
      min = (min + "").length === 1 ? "0" + min : min;
      var sec = Math.round(duration % 60);
      sec = (sec + "").length === 1 ? "0" + sec : sec;
      min = min || "00";
      sec = sec || "00";
      return min + ":" + sec;
    },
  },
  components: {
    PreviewRecord,
    Rights,
  },
};
</script>

<style lang="scss" scoped>
.topbar-preview {
  position: relative;
  width: 100%;
  height: 100%;
}

.mask-content {
  position: absolute;
  top: 0;
  left: 0;
  z-index: 5;
  width: 100%;
  height: 100%;

  > div {
    position: absolute;
    background: rgba(0, 0, 0, 0.7);
  }
  .mask-top,
  .mask-bottom {
    width: 100%;
  }
}

.preview-close {
  position: absolute;
  width: 40px;
  height: 40px;
  text-align: right;
  border-top-left-radius: 6px;
  border-top-right-radius: 6px;
  background-color: rgba(0, 0, 0, 0);
  z-index: 15;
  .vip-material-list {
    background: #ffffff;
    position: absolute;
    right: 50%;
    margin-right: -160px;
    z-index: 9;
  }
  div.vip-tip {
    position: absolute;
    top: -25px;
    height: 34px;
    width: 100%;
    line-height: 34px;
    display: flex;
    justify-content: center;
    span {
      color: #fff;
    }
    .details-link {
      position: relative;
    }
    a {
      color: #fff;
      text-decoration: underline;
      cursor: pointer;
    }
  }

  div.close-button {
    position: absolute;
    right: -32px;
    top: 28px;
    width: 30px;
    cursor: pointer;
  }

  i {
    position: relative;
    left: -9px;
    top: 4px;
    width: 5px;
    height: 27px;
    border-radius: 3px;
    background: #fff;
    transform: rotate(45deg);
    display: inline-block;

    &::after {
      content: "";
      position: absolute;
      top: 0;
      left: 0;
      width: 5px;
      height: 27px;
      border-radius: 3px;
      background: #fff;
      transform: rotate(270deg);
    }
  }
}
.preview-watermark {
  position: absolute;
  cursor: default;
}

.vip-mask {
  position: absolute;
  font-weight: bold;

  > div {
    color: #fff;
    opacity: 0.15;
    text-shadow: 0 0 7px rgba(0, 0, 0, 0.5);
  }

  > div.contain-vips {
    width: 100%;
    height: 97%;
    margin-top: 1%;
    opacity: 1;
    background: url("../../../static/animengine/img/icon-default-vip-mask.png")
      no-repeat center;
    background-size: contain;
  }
}

.time-volume {
  position: absolute;
  display: flex;
  align-items: center;
  width: 143px;
  height: 30px;
  background: rgba(0, 0, 0, 0.6);
  color: #fff;
  border-radius: 5px;
  z-index: 15;

  > div {
    margin-left: 15px;
  }

  .volume {
    position: relative;
    width: 17px;
    height: 30px;
    cursor: pointer;
    background: url("../../../static/svg/volume-white.svg") no-repeat center;

    &:hover {
      .volume-slider {
        display: block;
      }
    }

    .volume-slider {
      display: none;
      position: absolute;
      bottom: 30px;
      left: -2px;
      width: 20px;
      height: 100px;
      background: rgba(0, 0, 0, 0.6);
      border-top-left-radius: 3px;
      border-top-right-radius: 3px;

      * {
        box-sizing: border-box;
        -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
      }

      .v-slider-rc {
        position: absolute;
        top: 15px;
        height: 70px;
        width: 100%;
        padding: 0 8px;
        touch-action: none;
      }

      .v-slider-rail {
        position: absolute;
        width: 4px;
        height: 100%;
        background: #fff;
      }

      .v-slider-track {
        position: absolute;
        bottom: 0;
        background-color: #5778fb;
        width: 4px;
      }

      .v-slider-handle {
        position: absolute;
        margin-left: -4px;
        margin-bottom: -4px;
        width: 12px;
        height: 12px;
        background-color: #5778fb;
        border: 0;
        border-radius: 50%;
        cursor: -webkit-grab;
        cursor: grab;
        touch-action: pan-x;
      }
    }
  }
}

.video-control {
  position: absolute;
  height: 80px;
  background-color: #f0f0f8;
  border-bottom-left-radius: 6px;
  border-bottom-right-radius: 6px;
  z-index: 15;

  .slider-conntent {
    width: 100%;
    display: flex;
    margin-top: -5px;

    .icon-before,
    .icon-after {
      margin-top: 5px;
      width: 7px;
      height: 6px;
    }
    .icon-before {
      background-color: #5778fb;
    }
    .icon-after {
      background-color: rgba(0, 0, 0, 0.5);
    }
  }

  .rc-slider {
    position: relative;
    height: 15px;
    padding: 5px 0;
    width: calc(100% - 14px);
    -ms-touch-action: none;
    touch-action: none;
    -webkit-box-sizing: border-box;
    box-sizing: border-box;
    -webkit-tap-highlight-color: rgba(0, 0, 0, 0);

    * {
      -webkit-box-sizing: border-box;
      box-sizing: border-box;
      -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
    }

    .rc-slider-rail {
      position: absolute;
      width: 100%;
      background-color: rgba(0, 0, 0, 0.5);
      height: 6px;
    }
    .rc-slider-track {
      position: absolute;
      background-color: #5778fb;
      height: 6px;
      left: 0%;
      width: 69.1515%;
    }
    .rc-slider-handle {
      position: absolute;
      margin-left: -8px;
      margin-top: -5px;
      left: 69.1515%;
      width: 16px;
      height: 16px;
      background-color: #5778fb;
      border: 0;
      cursor: -webkit-grab;
      cursor: grab;
      border-radius: 50%;
      -ms-touch-action: pan-x;
      touch-action: pan-x;
    }
  }

  .control-button {
    position: relative;
    display: flex;
    justify-content: center;
    height: 69px;
    margin-top: -2px;

    > div {
      width: 40px;
      height: 40px;
      margin-top: 15px;
      cursor: pointer;

      &:last-child {
        margin-left: 25px;
      }
    }
    .play {
      background: url("../../../static/svg/play.svg");
      &:hover {
        background: url("../../../static/svg/play-active.svg");
      }
    }
    .pause {
      background: url("../../../static/svg/pause.svg");
      &:hover {
        background: url("../../../static/svg/pause-active.svg");
      }
    }
    .stop {
      background: url("../../../static/svg/stop.svg");
      &:hover {
        background: url("../../../static/svg/stop-active.svg");
      }
    }

    .share {
      position: absolute;
      right: 1em;
      top: 50%;
      margin-top: -20px;
      width: 160px;
      height: 40px;
      border-radius: 8px;
      color: #ffffff;
      text-align: center;
      line-height: 40px;
      cursor: pointer;
    }
  }
}

.record-control {
  position: absolute;
  height: 158px;
  background-color: #f0f0f8;
  border-bottom-left-radius: 6px;
  border-bottom-right-radius: 6px;
  z-index: 15;
}
</style>



// WEBPACK FOOTER //
// src/components/modal/preview.vue